import { LogoTopSection } from "@circle-react/components/Spaces/SidebarV2/LogoTopSection";

export const MainCommunityDropdown = () => (
  <div className="absolute left-5">
    <LogoTopSection />
  </div>
);
